enum MetricType {
	Live = '75cb0b56-42db-42ab-af15-8eab3262fb35',
	PIT = '836249f0-9ea0-4c94-bed1-901272bf4e92',
}

export { MetricType }
